// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"3e341111","872":"3e341111"}[chunkId] + ".chunk.css";
};